export function numberFixed(num, precision) {
  var str = "".concat(num).replace(/。/g, ".");
  var len1 = str.substring(0, 1);
  var len2 = str.substring(1, 2);
  //如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && len1 === "0" && len2 !== ".") {
    str = str.substring(1, 2);
  }
  //第一位不能是.
  if (len1 === ".") {
    str = "";
  }
  //限制只能输入一个小数点
  if (str.indexOf(".") !== -1) {
    var str_ = str.substring(str.indexOf(".") + 1);
    if (str_.indexOf(".") !== -1) {
      str = str.substring(0, str.indexOf(".") + str_.indexOf(".") + 1);
    }
  }
  //正则替换
  str = "".concat(str.indexOf("-") === 0 ? "-" : "").concat(str.replace(/[^\d^\\.]+/g, "")); // 保留数字和小数点
  if (precision !== undefined && precision >= 0) {
    str = str.replace(new RegExp("(\\.\\d{".concat(precision, "})\\d+$"), "g"), "$1"); // 小数点后只能输两位
  }

  if (precision === 0) {
    str = str.replace(".", "");
  }
  return str;
}